import useToastContext from "hooks/useToastContext";
import { AiFillEdit } from "react-icons/ai";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { useContext } from "react";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { BsArrowUpShort } from "react-icons/bs";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const CityList = ({ cityList, allCity, page, handleEdit, sort, setSort, manager }) => {
  const notification = useToastContext();
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  const handelStatusChangeList = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.cityStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allCity();
      }
    } catch (error) {
      console.log("error in get all city list==>>>>", error.message);
    }
  };

  return (
    <div>
      <div className="p-3">
        <div className="relative rounded-lg border overflow-x-auto ">
          <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <TableHeaderCell text={t("SR_NO")} />
                <TableHeaderCell text={t("COUNTRY")} />
                   <TableHeaderCell text={t("STATE")} />
                <TableHeaderCell text={t("CITY")} />
                {/* <TableHeaderCell text={t("ZIPCODE")} /> */}
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => {
                    if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortType: "asc",
                        sortBy: "createdAt",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("CREATED_DATE")}</span>
                    <span>
                      {sort.sortType === "asc" && sort.sortBy === "createdAt" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 rotate-180 h-4 " />}
                    </span>
                  </div>
                </th>

                <th className="py-3 px-6 text-center" scope="col">
                  {t("O_STATUS")}
                </th>
                {(manager?.edit || user?.role === "admin") && (
                  <th scope="col" className="px-6 text-center py-3 ">
                    {t("O_ACTION")}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {cityList &&
                cityList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="border-r text-gray-900 py-4 px-6 ">{item?.Country?.name}</td>
                        <td className="px-6 border-r py-4 text-gray-900">{item?.State?.name}</td>
                      <td className="px-6 border-r py-4 text-gray-900">{item?.name}</td>
                      {/* <td className="px-6 border-r py-4 text-gray-900">{item?.zipcode}</td> */}
                      <td className="py-4 px-6 text-gray-900 border-r text-left ">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>

                      <td className="px-6 border-r py-4 text-center text-gray-900">
                        <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="inline-flex cursor-pointer relative items-center ">
                          <input
                            checked={item?.status === "active"}
                            type="checkbox"
                            className="sr-only peer"
                            onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChangeList)}
                          />
                          <div className="w-10 h-5 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 bg-gray-200 rounded-full peer peer-focus:ring-0 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                        </label>
                      </td>
                      {(manager?.edit || user?.role === "admin") && (
                        <td className="py-4 px-6 border-l text-gray-900">
                          <div className="">
                            <ul className="flex justify-center">
                              <li className="px-2 py-2 hover:bg-white hover:text-LightBlue" onClick={() => handleEdit(item)}>
                                <a title="Edit city" data-bs-toggle="tooltip" className="hover:text-blue-700 transition duration-150 ease-in-out">
                                  {" "}
                                  <AiFillEdit className="w-5 h-5 text-slate-600 cursor-pointer " />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              {isEmpty(cityList) ? (
                <tr className="text-center bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={6}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CityList;
